// @flow
import * as React from 'react'

const LocationContext = React.createContext({
  detailOpen: false,
  toggleDetailOpen: () => {},
})

export default LocationContext
